/* eslint-disable */
import { Card, Checkbox, Container, FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';

import { Box, Button, IconButton, Stack, TextField } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/styles';
import ClearIcon from '@mui/icons-material/Clear';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Form, FormikProvider, useFormik } from 'formik';
import xlsx from 'json-as-xlsx';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import { ToastContainer } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { LoadingComponent } from 'src/pages/pageLoader';
import permissionAuth from 'src/utils/permissionAuth';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import CreatePDF from './CreatePDF';
import TablePagination from '@mui/material/TablePagination';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

var screenCode = "FARMERSANDCOLLECTORSWISEPURCHASESUMMARYREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>

            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function FarmersAndCollectorsWisePurchaseSummaryReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();

    const classes = useStyles();
    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [cropAvailability, setCropAvailability] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        cropCategoryID: '',
        cropID: '',
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [totalValues, setTotalValues] = useState({
        totalFnetAmount: 0,
        totalRealizedPrice: 0,
        totalFpTotal: 0,
        totalCnetAmount: 0,
        totalCRealizedPrice: 0,
        totalCpTotal: 0,
        totalTotalKg: 0,
        totalTotalRs: 0,
        totalFPercentage: 0,
        totalCPercentage: 0,
    });

    const cropAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
        cropCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        cropID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        cropCategoryID: '',
        cropID: '',
        toDate: '',
        fromDate: ''
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: cropAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMERSANDCOLLECTORSWISEPURCHASESUMMARY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        let newRes = await services.GetFarmersAndCollectorsWisePurchaseSummaryReport(
            selectedOptions.map(x => x).join(',').toString(),
            selectedProductOptions.map(x => x).join(',').toString(),
            (fromDate).toISOString(),
            (toDate).toISOString(),
        );
        var result = [];
        newRes.forEach(x => {
            var orderDate = x.orderDate.split('T')[0]
            var duplicateDate = result.find(y => y.operationEntityID === x.operationEntityID
                && y.cropID === x.cropID
                && y.orderDate === orderDate);

            if (x.isVirtualPlot == false) {
                if (duplicateDate) {
                    duplicateDate.cropID = x.cropID;
                    duplicateDate.factoryName = x.factoryName;
                    duplicateDate.fnetAmount = duplicateDate.fnetAmount + x.netAmount;
                    duplicateDate.cnetAmount = duplicateDate.cnetAmount + 0;
                    duplicateDate.operationEntityID = x.operationEntityID;
                    duplicateDate.orderDate = orderDate;
                    duplicateDate.productCode = x.productCode;
                    duplicateDate.productName = x.productName;
                    duplicateDate.realizedPrice = x.realizedPrice;
                }
                else {
                    result.push({
                        cropID: x.cropID,
                        factoryName: x.factoryName,
                        fnetAmount: x.netAmount,
                        cnetAmount: 0,
                        operationEntityID: x.operationEntityID,
                        orderDate: orderDate,
                        productCode: x.productCode,
                        productName: x.productName,
                        realizedPrice: x.realizedPrice
                    });
                }
            }
            else {
                if (duplicateDate) {
                    duplicateDate.cropID = x.cropID;
                    duplicateDate.factoryName = x.factoryName;
                    duplicateDate.fnetAmount = duplicateDate.fnetAmount + 0;
                    duplicateDate.cnetAmount = duplicateDate.cnetAmount + x.netAmount;
                    duplicateDate.operationEntityID = x.operationEntityID;
                    duplicateDate.orderDate = orderDate;
                    duplicateDate.productCode = x.productCode;
                    duplicateDate.productName = x.productName;
                    duplicateDate.realizedPrice = x.realizedPrice;
                }
                else {
                    result.push({
                        cropID: x.cropID,
                        factoryName: x.factoryName,
                        fnetAmount: 0,
                        cnetAmount: x.netAmount,
                        operationEntityID: x.operationEntityID,
                        orderDate: orderDate,
                        productCode: x.productCode,
                        productName: x.productName,
                        realizedPrice: x.realizedPrice
                    });
                }
            }
        });
        result.forEach(x => {
            x.fpTotal = x.fnetAmount * x.realizedPrice
            x.cpTotal = x.cnetAmount * x.realizedPrice
            x.totalKg = x.fnetAmount + x.cnetAmount
            x.totalRs = x.fpTotal + x.cpTotal
            x.fPercentage = (x.fnetAmount / x.totalKg) * 100
            x.cPercentage = (x.cnetAmount / x.totalKg) * 100
        })
        setCropAvailability(result);
        createDataForExcel(newRes);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
        setToDate(new Date());
        setFromDate(new Date());
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }

    useEffect(() => {
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setCropAvailability([]);
        setValues({
            ...values,
            cropCategoryID: '',
            cropID: ''
        })
        setSelectedCategoryOptions([])
        setToDate(new Date());
        setFromDate(new Date());
        setSelectedProductOptions([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setCropAvailability([]);
        setValues({
            ...values,
            cropID: ''
        })
        setToDate(new Date());
        setFromDate(new Date());
        setSelectedProductOptions([]);
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setCropAvailability([]);
        setFromDate(new Date())
        setToDate(new Date())
    }, [formik.values.cropID]);

    useEffect(() => {
        setCropAvailability([]);
    }, [toDate]);

    useEffect(() => {
        setCropAvailability([]);
    }, [fromDate]);

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setCropAvailability([]);
    }, [selectedProductOptions])

    useEffect(() => {
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        if (cropAvailability.length != 0) {
            calculateTotalQty()
        }
    }, [cropAvailability]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(cropAvailability);
        var settings = {
            sheetName: 'Farmer Collector Purchase',
            fileName: 'Farmers Collector Purchase',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Farmer Collector Purchase',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Date': x.orderDate,
                    'FCC/s': x.factoryName,
                    'SKU Code': x.productCode,
                    'SKU': x.productName,
                    'Purchase From Farmers (Kg/Unit)': x.fnetAmount == 0 ? '-' : parseFloat(x.fnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Realized Price Purchased From Farmers (Rs)': (x.realizedPrice == 0 || x.fnetAmount == 0) ? '-' : parseFloat(x.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Total Purchase Value From Farmers (Rs)': x.fpTotal == 0 ? '-' : parseFloat(x.fpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Purchase From Collector (Kg/Unit)': x.cnetAmount == 0 ? '-' : parseFloat(x.cnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Realized Price Purchased from Collector (Rs)': x.cnetAmount == 0 || x.realizedPrice == 0 ? '-' : parseFloat(x.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Total Purchase Value From Collector (Rs)': x.cpTotal == 0 ? '-' : parseFloat(x.cpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Total Purchase Amount (Kg/Unit)': x.totalKg == 0 ? '-' : parseFloat(x.totalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Total Purchase Amount (Rs)': x.totalRs == 0 ? '-' : parseFloat(x.totalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Purchase % of Farmers': x.fPercentage == 0 ? '-' : parseFloat(x.fPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Purchase % of Collectors': x.cPercentage == 0 ? '-' : parseFloat(x.cPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                }
                res.push(vr);
            });

            res.push({});

            var vr2 = {
                'Date': 'Total',
                'Purchase From Farmers (Kg/Unit)': totalValues.totalFnetAmount == 0 ? '-' : parseFloat(totalValues.totalFnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Realized Price Purchased From Farmers (Rs)': totalValues.totalRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Total Purchase Value From Farmers (Rs)': totalValues.totalFpTotal == 0 ? '-' : parseFloat(totalValues.totalFpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Purchase From Collector (Kg/Unit)': totalValues.totalCnetAmount == 0 ? '-' : parseFloat(totalValues.totalCnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Realized Price Purchased from Collector (Rs)': totalValues.totalCRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalCRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Total Purchase Value From Collector (Rs)': totalValues.totalCpTotal == 0 ? '-' : parseFloat(totalValues.totalCpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Total Purchase Amount (Kg/Unit)': totalValues.totalTotalKg == 0 ? '-' : parseFloat(totalValues.totalTotalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Total Purchase Amount (Rs)': totalValues.totalTotalRs == 0 ? '-' : parseFloat(totalValues.totalTotalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Purchase % of Farmers': totalValues.totalFPercentage == 0 ? '-' : parseFloat(totalValues.totalFPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Purchase % of Collectors': totalValues.totalCPercentage == 0 ? '-' : parseFloat(totalValues.totalCPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr2);
            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName,
            cropCategoryID: categoryName.map(x => x).join(','),
            cropID: productName.map(x => x).join(','),
            fromDate: (fromDate).toISOString().split('T')[0],
            toDate: (toDate).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    function calculateTotalQty() {

        const totalFnetAmount = cropAvailability.reduce((accumulator, current) => accumulator + current.fnetAmount, 0);
        const totalRealizedPrice = cropAvailability.reduce((accumulator, current) => current.fnetAmount > 0 ? accumulator + current.realizedPrice : accumulator, 0);
        const totalFpTotal = cropAvailability.reduce((accumulator, current) => accumulator + current.fpTotal, 0);
        const totalCnetAmount = cropAvailability.reduce((accumulator, current) => accumulator + current.cnetAmount, 0);
        const totalCRealizedPrice = cropAvailability.reduce((accumulator, current) => {
            return current.cnetAmount !== 0 ? accumulator + current.realizedPrice : accumulator;
        }, 0);
        const totalCpTotal = cropAvailability.reduce((accumulator, current) => accumulator + current.cpTotal, 0);
        const totalTotalKg = cropAvailability.reduce((accumulator, current) => accumulator + current.totalKg, 0);
        const totalTotalRs = cropAvailability.reduce((accumulator, current) => accumulator + current.totalRs, 0);
        const totalFPercentage = (totalFpTotal / totalTotalRs) * 100;
        const totalCPercentage = (totalCpTotal / totalTotalRs) * 100;

        setTotalValues({
            ...totalValues,
            totalFnetAmount: totalFnetAmount,
            totalRealizedPrice: totalRealizedPrice,
            totalFpTotal: totalFpTotal,
            totalCnetAmount: totalCnetAmount,
            totalCRealizedPrice: totalCRealizedPrice,
            totalCpTotal: totalCpTotal,
            totalTotalKg: totalTotalKg,
            totalTotalRs: totalTotalRs,
            totalFPercentage: totalFPercentage,
            totalCPercentage: totalCPercentage
        })

    };
    return (
        <>
            <LoadingComponent />
            <Page title="Farmers and Collectors Wise Purchase Summary |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader
                        path={"/farmersAndCollectorsWisePurchaseSummaryReport"}
                        btname="Add"
                        pageName="Farmers and Collectors Wise Purchase Summary"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group *</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length == 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropCategoryID && errors.cropCategoryID && (
                                            <FormHelperText>{errors.cropCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropID && errors.cropID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product"
                                            disabled={selectedCategoryOptions.length == 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropID && errors.cropID && (
                                            <FormHelperText>{errors.cropID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>

                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                maxDate={new Date()}
                                                {...params} />}
                                            maxDate={new Date()}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}

                                                {...params} />}
                                            maxDate={new Date()}
                                        />
                                    </LocalizationProvider>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {cropAvailability.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer >
                                                        <Table aria-label="caption table">

                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align={'center'} style={{ whiteSpace: "nowrap" }}>Date</TableCell>
                                                                    <TableCell align={'center'}>FCC/s</TableCell>
                                                                    <TableCell align={'center'}>SKU Code</TableCell>
                                                                    <TableCell align={'center'}>SKU</TableCell>
                                                                    <TableCell align={'center'}>Purchase&nbsp;From Farmers&nbsp;(Kg/Unit)</TableCell>
                                                                    <TableCell align={'center'}>Realized&nbsp;Price&nbsp;Purchased From&nbsp;Farmers&nbsp;(Rs)</TableCell>
                                                                    <TableCell align={'center'}>Total&nbsp;Purchase&nbsp;Value From&nbsp;Farmers&nbsp;(Rs)</TableCell>
                                                                    <TableCell align={'center'}>Purchase&nbsp;From Collector&nbsp;(Kg/Unit)</TableCell>
                                                                    <TableCell align={'center'}>Realized&nbsp;Price&nbsp;Purchased from&nbsp;Collector&nbsp;(Rs)</TableCell>
                                                                    <TableCell align={'center'}>Total&nbsp;Purchase&nbsp;Value From&nbsp;Collector&nbsp;(Rs)</TableCell>
                                                                    <TableCell align={'center'}>Total&nbsp;Purchase Amount (Kg/Unit)</TableCell>
                                                                    <TableCell align={'center'}>Total&nbsp;Purchase Amount (Rs)</TableCell>
                                                                    <TableCell align={'center'}>Purchase&nbsp;%&nbsp;of Farmers </TableCell>
                                                                    <TableCell align={'center'}>Purchase&nbsp;%&nbsp;of Collectors</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(rowsPerPage > 0
                                                                    ? cropAvailability.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    : cropAvailability
                                                                ).map((data, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", whiteSpace: "nowrap" }}>
                                                                            {data.orderDate}
                                                                        </TableCell>
                                                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.factoryName}
                                                                        </TableCell>
                                                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.productCode}
                                                                        </TableCell>
                                                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.productName}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.fnetAmount == 0 ? '-' : parseFloat(data.fnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {(data.realizedPrice == 0 || data.fnetAmount == 0) ? '-' : parseFloat(data.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.fpTotal == 0 ? '-' : parseFloat(data.fpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.cnetAmount == 0 ? '-' : parseFloat(data.cnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.cnetAmount == 0 || data.realizedPrice == 0 ? '-' : parseFloat(data.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.cpTotal == 0 ? '-' : parseFloat(data.cpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.totalKg == 0 ? '-' : parseFloat(data.totalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.totalRs == 0 ? '-' : parseFloat(data.totalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.fPercentage == 0 ? '-' : parseFloat(data.fPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {data.cPercentage == 0 ? '-' : parseFloat(data.cPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableRow>
                                                                <TableCell align="center" colSpan={4} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalFnetAmount == 0 ? '-' : parseFloat(totalValues.totalFnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalFpTotal == 0 ? '-' : parseFloat(totalValues.totalFpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalCnetAmount == 0 ? '-' : parseFloat(totalValues.totalCnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalCRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalCRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalCpTotal == 0 ? '-' : parseFloat(totalValues.totalCpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalTotalKg == 0 ? '-' : parseFloat(totalValues.totalTotalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalTotalRs == 0 ? '-' : parseFloat(totalValues.totalTotalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalFPercentage == 0 ? '-' : parseFloat(totalValues.totalFPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                                                                    {totalValues.totalCPercentage == 0 ? '-' : parseFloat(totalValues.totalCPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                            </TableRow>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                        component="div"
                                                        count={cropAvailability.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActions}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Farmers and Collectors Wise Purchase Summary Report" />}</>
                        </Form>
                    </FormikProvider>
                    {cropAvailability.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Farmers and Collectors Wise Purchase Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={cropAvailability}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}